import { atom } from 'jotai'
import { AMParcelOverview } from 'src/common-services'
import { atomFamily } from 'src/utils/jotai'
import US_STATES from 'src/components/states-layer/us-states.json'
import { StateFeatureProperties } from 'src/components/states-layer'
import { entityParcelsOverviewById } from 'src/v2/state/owner-reveal/entity-parcels'

export const parcelsByStateById = atomFamily((entityId: string) =>
  atom(async (get) => {
    const parcels = await get(entityParcelsOverviewById(entityId))
    if (!parcels) {
      return {}
    }

    const parcelsByState: Record<string, AMParcelOverview[]> = {}
    parcels.forEach((parcel) => {
      if (!parcelsByState[parcel.state]) {
        parcelsByState[parcel.state] = []
      }
      parcelsByState[parcel.state].push(parcel)
    })
    return parcelsByState
  })
)

export const activityHeatmapFeaturesById = atomFamily((entityId: string) =>
  atom(async (get) => {
    const _parcelsByState = await get(parcelsByStateById(entityId))
    if (!_parcelsByState) {
      return []
    }

    const maxParcels = Math.max(...Object.values(_parcelsByState).map((parcels) => parcels.length))

    const features: GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon, StateFeatureProperties>[] = []
    Object.entries(_parcelsByState).forEach(([state, parcels]) => {
      const stateFeature = US_STATES.features.find((feature) => feature.properties.code === state)
      if (!stateFeature) {
        return
      }

      const opacity = parcels.length / maxParcels

      features.push({
        type: 'Feature',
        properties: {
          stateName: stateFeature.properties.name,
          stateCode: stateFeature.properties.code,
          totalParcels: parcels.length,
          opacity: opacity > 0.95 ? 0.95 : opacity,
        },
        geometry: stateFeature.geometry as any,
      })
    })

    return features
  })
)

export const selectedStateCode = atom<string | undefined>(undefined)

export const parcelsFeaturesByStateCode = atomFamily((params: { stateCode: string | undefined; entityId: string }) =>
  atom(async (get) => {
    const { entityId, stateCode } = params
    if (!stateCode) {
      return []
    }

    const parcels = (await get(parcelsByStateById(entityId)))[stateCode] ?? []
    return parcels.map((parcel) => ({
      type: 'Feature',
      properties: {
        ...parcel,
        owners: JSON.stringify(parcel.owners),
      },
      geometry: parcel.geometry,
    }))
  })
)
